import {
  AddOutlined,
  RemoveOutlined,
  ShoppingCart,
  ShoppingCartOutlined,
} from "@mui/icons-material";
import { Button, IconButton, Stack } from "@mui/material";
import { Box } from "@mui/system";
import React,{useState} from "react";
import { useHistory,Link } from "react-router-dom";
import "./Cart.css";
import Checkout from "./Checkout";

// Definition of Data Structures used
/**
 * @typedef {Object} Product - Data on product available to buy
 * 
 * @property {string} name - The name or title of the product
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */

/**
 * @typedef {Object} CartItem -  - Data on product added to cart
 * 
 * @property {string} name - The name or title of the product in cart
 * @property {string} qty - The quantity of product added to cart
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} productId - Unique ID for the product
 */

/**
 * Returns the complete data on all products in cartData by searching in productsData
 *
 * @param { Array.<{ productId: String, qty: Number }> } cartData
 *    Array of objects with productId and quantity of products in cart
 * 
 * @param { Array.<Product> } productsData
 *    Array of objects with complete data on all available products
 *
 * @returns { Array.<CartItem> }
 *    Array of objects with complete data on products in cart
 *
 */

export const generateCartItemsFrom = (cartData, productsData) => {
  console.log("consoling from generateCartItemsFrom /Cart.js");
  console.log("cartData",cartData);
  console.log("productsData",productsData);
  let CartItem=[];
  for(let cd=0;cd<cartData.length;cd++)
  {
    for(let i=0;i<productsData.length;i++)
    {
      if(cartData[cd]["productId"]===productsData[i]["_id"])
      {
        let newObj={...productsData[i]};
        newObj['productId']=newObj["_id"]
        newObj["qty"]=cartData[cd]["qty"];
        CartItem.push(newObj);
      }
    }
  }
  console.log(CartItem);
  return CartItem;
};

/**
 * Get the total value of all products added to the cart
 *
 * @param { Array.<CartItem> } items
 *    Array of objects with complete data on products added to the cart
 *
 * @returns { Number }
 *    Value of all items in the cart
 *
 */
export const getTotalCartValue = (items = []) => {
  let amount=0;
  for(let item=0;item<items.length;item++)
  {
    amount=amount+(items[item]["qty"]*items[item]["cost"]);
  }
  return amount;
};
export const getTotalItems = (items = []) => {
  let totalItems=0;
  for(let item=0;item<items.length;item++)
  {
    totalItems=totalItems+items[item]["qty"];
  }
  return totalItems;
};


/**
 * Component to display the current quantity for a product and + and - buttons to update product quantity on cart
 * 
 * @param {Number} value
 *    Current quantity of product in cart
 * 
 * @param {Function} handleAdd
 *    Handler function which adds 1 more of a product to cart
 * 
 * @param {Function} handleDelete
 *    Handler function which reduces the quantity of a product in cart by 1
 * 
 * @param {Boolean} isReadOnly
 *    If product quantity on cart is to be displayed as read only without the + - options to change quantity
 * 
 */
const ItemQuantity = ({
  value,
  handleAdd,
  handleDelete,
}) => {
  console.log("handleAdd",handleAdd)
  return (
    <Stack direction="row" alignItems="center">
      <IconButton size="small" color="primary" onClick={()=>{
        value=value-1;
        return(handleDelete(value))
      }}>
        <RemoveOutlined />
      </IconButton>
      <Box padding="0.5rem" data-testid="item-qty">
        {value}
      </Box>
      <IconButton size="small" color="primary" onClick={()=>{
        value=value+1;
        return(handleDelete(value))
      }}>
        <AddOutlined />
      </IconButton>
    </Stack>
  );
};

/**
 * Component to display the Cart view
 * 
 * @param { Array.<Product> } products
 *    Array of objects with complete data of all available products
 * 
 * @param { Array.<Product> } items
 *    Array of objects with complete data on products in cart
 * 
 * @param {Function} handleDelete
 *    Current quantity of product in cart
 * 
 * @param {Boolean} isReadOnly
 *    If product quantity on cart is to be displayed as read only without the + - options to change quantity
 * 
 */
const Cart = ({
  products,
  items=[],
  handleQuantity,
  isReadOnly
}) => {
  const history=useHistory();
  const shippingCharges=0;
  if (!items.length) {
    return (
      <Box className="cart empty">
        <ShoppingCartOutlined className="empty-cart-icon" />
        <Box color="#aaa" textAlign="center">
          Cart is empty. Add more items to the cart to checkout.
        </Box>
      </Box>
    );
  }
  // console.log("handleQuant",handleQuantity)
  return (
    <>
     {/*cart view for products page only  */}
      {!isReadOnly &&
                      <Box className="cart">
                      {/* TODO: CRIO_TASK_MODULE_CART - Display view for each cart item with non-zero quantity */}
                      <Box
                        padding="1rem"
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Box color="#3C3C3C" alignSelf="center">
                          Order total
                        </Box>
                        <Box
                          color="#3C3C3C"
                          fontWeight="700"
                          fontSize="1.5rem"
                          alignSelf="center"
                          data-testid="cart-total"
                        >
                          ${getTotalCartValue(items)}
                        </Box>
                      </Box>
                      {/* cards start */}
                      {items.map((item)=>(
                                    <Box display="flex" alignItems="flex-start" padding="1rem" key={item.productId}
                                    style={{backgroundColor:"#f2f7ff", margin:"4px"}}  
                                    >
                                    <Box className="image-container">
                                        <img
                                            // Add product image
                                            src={item.image}
                                            // Add product name as alt eext
                                            alt={item.name}
                                            width="100%"
                                            height="100%"
                                        />
                                    </Box>
                                    <Box
                                        display="flex"
                                        flexDirection="column"
                                        justifyContent="space-between"
                                        height="6rem"
                                        paddingX="1rem"
                                    >
                                        <div>{item.name}</div>
                                        <Box
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="center"
                                        >
                                        <ItemQuantity
                                        // Add required props by checking implementation
                                        value={item.qty}
                                        handleAdd={(q)=>handleQuantity(item.productId,q)}
                                        handleDelete={(q)=>handleQuantity(item.productId,q)}
                                        />
                                        <Box padding="0.5rem" fontWeight="700">
                                            ${item.cost}
                                        </Box>
                                        </Box>
                                    </Box>
                                </Box>
                ))}

                      {/* cards end */}
                      <Box display="flex" justifyContent="flex-end" className="cart-footer">
                      <Button
                          color="primary"
                          variant="contained"
                          startIcon={<ShoppingCart />}
                          className="checkout-btn"
                          onClick={() => history.push("/checkout")}
                        >
                          Checkout
                        </Button>

                        
                      </Box>
                    </Box>
      }
      
      {/*cart view for checkout page only  */}


      {isReadOnly && 
            <>

            <Box className="cart">
                    {/* TODO: CRIO_TASK_MODULE_CART - Display view for each cart item with non-zero quantity */}
                    
                    {/* cards start */}
                    {items.map((item)=>(
                                  <Box display="flex" alignItems="flex-start" padding="1rem" key={item.productId}
                                  style={{backgroundColor:"#fffefc", marginLeft:"4px",marginRight:"4px",marginTop:"4px"}}  
                                  >
                                  <Box className="image-container">
                                      <img
                                          // Add product image
                                          src={item.image}
                                          // Add product name as alt eext
                                          alt={item.name}
                                          width="100%"
                                          height="100%"
                                      />
                                  </Box>
                                  <Box
                                      display="flex"
                                      flexDirection="column"
                                      justifyContent="space-between"
                                      height="6rem"
                                      paddingX="1rem"
                                  >
                                      <div>{item.name}</div>
                                      <Box
                                          display="flex"
                                          justifyContent="space-between"
                                          alignItems="center"
                                      >
                                      {/* <ItemQuantity
                                      // Add required props by checking implementation
                                      value={item.qty}
                                      handleAdd={(q)=>handleQuantity(item.productId,q)}
                                      handleDelete={(q)=>handleQuantity(item.productId,q)}
                                      /> */}
                                      <Box>
                                        Qty:{item.qty}
                                      </Box>
                                      <Box padding="0.5rem" fontWeight="700">
                                          ${item.cost}
                                      </Box>
                                      </Box>
                                      
                                  </Box>
                                  
                              </Box>
                              
              ))}
              {/* order total below mapping of products */}
              <Box
                                              padding="1rem"
                                              display="flex"
                                              justifyContent="space-between"
                                              alignItems="center"
                                              style={{backgroundColor:"#fffefc",
                                              marginLeft:"4px",
                                              marginRight:"4px"
                                              // width:"2rem"
                                            }}  
                                            >
                                              <Box color="#3C3C3C" alignSelf="center">
                                                Order total:
                                              </Box>
                                              <Box
                                                color="#3C3C3C"
                                                fontWeight="400"
                                                fontSize="1rem"
                                                alignSelf="center"
                                                data-testid="cart-total"
                                              >
                                                ${getTotalCartValue(items)}
                                              </Box>
                                            </Box>

                    {/* cards end */}
                   
                  </Box>
      
                {/* order details/summary */}
                <Box
                                              padding="1rem"
                                              display="flex"
                                              justifyContent="space-between"
                                              alignItems="center"
                                              style={{backgroundColor:"#fffefc",
                                              marginLeft:"12px",
                                              marginRight:"12px"
                                              // width:"2rem"
                                            }}  
                                            >
                                              <Box color="#3C3C3C" alignSelf="start" fontWeight="700" fontSize="1rem">
                                                Order Details
                                              </Box>
                                              
                  </Box>
                  <Box
                                              padding="1rem"
                                              display="flex"
                                              justifyContent="space-between"
                                              alignItems="center"
                                              style={{backgroundColor:"#fffefc",
                                              marginLeft:"12px",
                                              marginRight:"12px"
                                              // width:"2rem"
                                            }}  
                                            >
                                             
                                              <Box color="#3C3C3C" alignSelf="center">
                                                Products
                                              </Box>
                                              <Box
                                                color="#3C3C3C"
                                                fontWeight="400"
                                                fontSize="1rem"
                                                alignSelf="center"
                                                data-testid="cart-total"
                                              >
                                                {getTotalItems(items)}
                                              </Box>
                  </Box>
                  <Box
                                              padding="1rem"
                                              display="flex"
                                              justifyContent="space-between"
                                              alignItems="center"
                                              style={{backgroundColor:"#fffefc",
                                              marginLeft:"12px",
                                              marginRight:"12px"
                                              // width:"2rem"
                                            }}  
                                            >
                                             
                                              <Box color="#3C3C3C" alignSelf="center">
                                                Subtotal
                                              </Box>
                                              <Box
                                                color="#3C3C3C"
                                                fontWeight="400"
                                                fontSize="1rem"
                                                alignSelf="center"
                                                data-testid="cart-total"
                                              >
                                                ${getTotalCartValue(items)}
                                              </Box>
                  </Box>
                  <Box
                                              padding="1rem"
                                              display="flex"
                                              justifyContent="space-between"
                                              alignItems="center"
                                              style={{backgroundColor:"#fffefc",
                                              marginLeft:"12px",
                                              marginRight:"12px"
                                              // width:"2rem"
                                            }}  
                                            >
                                             
                                              <Box color="#3C3C3C" alignSelf="center">
                                                Shipping Charges
                                              </Box>
                                              <Box
                                                color="#3C3C3C"
                                                fontWeight="400"
                                                fontSize="1rem"
                                                alignSelf="center"
                                                data-testid="cart-total"
                                              >
                                                ${shippingCharges}
                                              </Box>
                  </Box>
                  <Box
                                              padding="1rem"
                                              display="flex"
                                              justifyContent="space-between"
                                              alignItems="center"
                                              style={{backgroundColor:"#fffefc",
                                              marginLeft:"12px",
                                              marginRight:"12px"
                                              // width:"2rem"
                                            }}  
                                            >
                                             
                                              <Box color="#3C3C3C" alignSelf="center" fontWeight="700" fontSize="0.85rem">
                                                Total
                                              </Box>
                                              <Box
                                                color="#3C3C3C"
                                                fontWeight="400"
                                                fontSize="1rem"
                                                alignSelf="center"
                                                data-testid="cart-total"
                                              >
                                                ${shippingCharges+getTotalCartValue(items)}
                                              </Box>
                  </Box>                   
            </>
      }
    </>
  );
};

export default Cart;
